
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TableRow extends Vue {
    @Prop({ default: 8 }) readonly cols!: number;
  }
